import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Consumables',
  components: {
    ConsumableComp: require('./consumable.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      consumables: [],
      warehouses: [],
      inventories: [],
      inventoryGroups: [],
      bConsumableDialog: false,
      bConfirmDialog: false,
      deleteConfirmMessage: '',
      editingConsumable: {

      },
      editingConsumableClone: {

      },
      message: '',
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.dataObj.appData.consumables.forEach(p => {
          if (!p.uuid || p.uuid.length === 0)
            p.uuid = uuidv4();
        });
        if (this.dataObj.appData.consumables)
          this.consumables = this.dataObj.appData.consumables;
        else
          this.dataObj.appData.consumables = [];
        this.warehouses = this.dataObj.appData.warehouses;


        this.filterInventories();
      });
    },
    filterInventories() {
      this.inventories = this.dataObj.appData.inventories.filter(p => p.inventoryType == 1);
      if (!this.inventories || this.inventories.length == 0) {
        this.inventoryGroups = [];
        return;
      }

      let groupIds = this.inventories.map(i => i.groupId);
      let uniqueGroupIds = groupIds.filter((value, index) => groupIds.indexOf(value) === index);
      this.inventoryGroups = this.dataObj.appData.inventoryGroups.filter(item => uniqueGroupIds.includes(item.value));
      this.inventoryGroups.unshift(this.dataObj.appData.inventoryGroups[0]);
    },
    formatMoney(number, decPlaces, decSep, thouSep) {
      decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSep = typeof decSep === "undefined" ? "." : decSep;
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - parseInt(i)).toFixed(decPlaces).slice(2) : "");
    },
    addConsumable() {
      this.editingConsumableClone = {
        isMultiple: false,
        selection: [],
        comment: '',
        cost: 0,
        dt: this.dataObj.appData.startDt,
        id: 0,
        inventoryId: 0,
        inventoryName: '',
        quantity: 0,
        warehouse: '',
        warehouseId: 0,
        uuid: uuidv4(),
        stations: this.dataObj.appData.stations,
      };
      this.editingConsumableClone.warehouses = this.warehouses.filter(w => w.group.id == this.dataObj.appData.stationId || w.selected);
      this.editingConsumableClone.inventories = this.inventories;
      this.editingConsumableClone.inventoryGroups = this.inventoryGroups;
      this.bConsumableDialog = true;
    },
    editConsumable(item) {
      this.editingConsumable = item;
      this.editingConsumableClone = JSON.parse(JSON.stringify(item));
      this.editingConsumableClone.warehouses = this.warehouses.filter(w => w.group.id == this.dataObj.appData.stationId || w.selected);
      this.editingConsumableClone.inventories = this.inventories;
      this.editingConsumableClone.inventoryGroups = this.inventoryGroups;
      this.editingConsumableClone.isMultiple = false;
      this.editingConsumableClone.total = item.total;
      this.editingConsumableClone.cost = item.cost;
      this.editingConsumableClone.selection = [];
      this.bConsumableDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('omApplication.DeleteConsumable') + ' [' + item.inventoryId + '. ' + item.inventoryName + '] ?';
      this.editingConsumable = item;
      this.bConfirmDialog = true;
    },
    removeConsumable() {
      this.dataObj.appData.consumables = this.dataObj.appData.consumables.filter(p => p.uuid !== this.editingConsumable.uuid);
      this.consumables = this.dataObj.appData.consumables;
    },
    saveConsumable() {
      if (!this.editingConsumableClone.cost || this.editingConsumableClone.cost <= 0) {
        this.$alertMsg(this.$t('validation.costError'));
        return;
      }

      if (!this.editingConsumableClone.inventoryId || this.editingConsumableClone.inventoryId < 0) {
        this.$alertMsg(this.$t('validation.invItemError'));
        return;
      }

      if (!this.editingConsumableClone.quantity || this.editingConsumableClone.quantity <= 0) {
        this.$alertMsg(this.$t('validation.qtyError'));
        return;
      }

      this.dataObj.appData.consumables = this.dataObj.appData.consumables.filter(p => p.uuid !== this.editingConsumableClone.uuid);
      const isMultiple = this.editingConsumableClone.isMultiple;
      const selection = this.editingConsumableClone.selection;

      delete this.editingConsumableClone.warehouses;
      delete this.editingConsumableClone.inventories;
      delete this.editingConsumableClone.inventoryGroups;

      if (isMultiple === false)
        this.dataObj.appData.consumables.push(this.editingConsumableClone);
      else {
        selection.forEach(p => {
          const consumable = JSON.parse(JSON.stringify(this.editingConsumableClone));
          const inventory = this.inventories.filter(e => e.id === p)[0];
          consumable.inventoryId = p;
          consumable.inventoryName = inventory.name;
          consumable.uuid = uuidv4();
          this.dataObj.appData.consumables.push(consumable);
        });
      }
      this.consumables = this.dataObj.appData.consumables;
      this.bConsumableDialog = false;
    },
    closeDialog() {
      this.bConsumableDialog = false;
    },
  },
  
}

